import { render, staticRenderFns } from "./Syarat.vue?vue&type=template&id=5b7929d7&scoped=true&"
import script from "./Syarat.vue?vue&type=script&lang=js&"
export * from "./Syarat.vue?vue&type=script&lang=js&"
import style0 from "./Syarat.vue?vue&type=style&index=0&id=5b7929d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7929d7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VContainer})
